/*========================================================================
 * $Id$
 *
 * Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2013
 *
 * Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
 * Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
 * Urheber festgelegten Stelle in der Funktion des Computerprogramms
 * angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
 * Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
 * Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
 * =========================================================================*/

define(["backbone", "service/channel", "jquery", "underscore"], function(Backbone, Channel, $, _) {

  /**
   *
   * EWSChannel wraps another channel and adapts request and responses.
   * 
   * Attributes:
   *
   * * parentChannel: the channel used for communicating
   *
   * Options:
   *
   * * urlTemplate: the OpenSearch url template (http://www.opensearch.org/Specifications/OpenSearch/1.1#OpenSearch_URL_template_syntax)
   *   (currently only searchTerm and count are usable)
   *
   * Mode of operation
   * -----------------
   *
   * Overwrites the **call**-function of Channel to adapt the request.
   * Overwrites the **success**-function of the wrapped channel to parse the response.
   *
   */
  var EWSChannel = Channel.extend({

    initialize: function (attributes, options) {
      options = options || {};
      this.urlTemplate = options.urlTemplate || "";
      Channel.prototype.initialize.apply(this, arguments);

      var that = this,
          parentChannel = this.get("parentChannel"),
          originalSuccess = parentChannel.success || parentChannel.prototype.success;

      parentChannel.success = function (data) {
        return originalSuccess.apply(parentChannel, [that.adaptResponse(data)].concat(Array.prototype.slice.apply(arguments, [1])));
      }
    },

    call: function(path, request, responseObserver) {
      var targetFolder;
      var constraint = request.source_context.constraints && request.source_context.constraints[0].unparsed;
      if (constraint && /folder/.test(constraint)) {
        targetFolder = /\bfolder:([^;]*)/.exec(constraint)[1];
      } else {
        targetFolder = "inbox";
      }
      var viewCount = request.count || 5;
      var userQuery = this.escapeXML(request.user.query.and[0].unparsed);

      var payload = '<soap:Envelope\
          xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/"\
          xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance"\
          xmlns:m="http://schemas.microsoft.com/exchange/services/2006/messages"\
          xmlns:t="http://schemas.microsoft.com/exchange/services/2006/types">\
          <soap:Header>\
            <t:RequestServerVersion Version="Exchange2013_SP1"></t:RequestServerVersion>\
          </soap:Header>\
          <soap:Body>\
            <m:FindItem Traversal="Shallow">\
              <m:ItemShape>\
                <t:BaseShape>AllProperties</t:BaseShape>\
              </m:ItemShape>\
              <m:IndexedPageItemView MaxEntriesReturned="' + viewCount + '" Offset="0" BasePoint="Beginning"></m:IndexedPageItemView>\
              <m:ParentFolderIds>\
                <t:DistinguishedFolderId Id="'+ targetFolder + '"></t:DistinguishedFolderId>\
              </m:ParentFolderIds>\
              <m:QueryString ReturnHighlightTerms="true">'+ userQuery +'</m:QueryString>\
            </m:FindItem>\
          </soap:Body>\
        </soap:Envelope>\
      ';

      var options = {
        headers: {
          'Accept': 'text/xml; charset=utf-8',
          'Content-Type': 'text/xml'
        }
      }

      if (this.isSearch(path)) {
        return this.get("parentChannel").call(this.getUrl(request), payload, responseObserver, {dataType:"xml"}, null, options);
      }

      var that = this,
          promise = new Channel.DeferredCallFinished(this);

      // return empty result for all other services
      _.defer(function () {
          that.success(
            {},
            promise,
            responseObserver
          );
      });

      return promise;
    },

    getUrl: function (request) {
      var query = request && request.user && request.user.query && request.user.query.unparsed,
          count = request && request.count;

      return this.urlTemplate.replace(/\{searchTerms\}/g, query).replace(/\{count\??\}/g, count);
    },

    isSearch: function (path) {
      return path === "search";
    },

    adaptResponse: function (data) {
      var items = data.documentElement.getElementsByTagName("t:Message");
      if (items.length === 0) {
        return {
          resultset: {
            result: []
          }
        };
      }
      var highlightedTerm = this.getHighlightedTerms(data);
      return {
        resultset: {
          results: this.mapXMLResults($.makeArray(items), highlightedTerm)
        }
      }
    },

    getHighlightedTerms: function(data) {
      var highlightedTerms = data.documentElement.getElementsByTagName("t:Value");
      var highlightedTerm;
      if (highlightedTerms.length > 0) {
        highlightedTerm = highlightedTerms[0].textContent;
      }
      var filteredTerm = this.removeSpecialCharacters(highlightedTerm);
      return filteredTerm;
    },

    removeSpecialCharacters: function(strTerm) {
      return strTerm.replace(/[^\w\s]/gi, '');
    },

    mapXMLResults: function(items, highlightedTerm) { 
      var that = this;

      var results = $.map(items, function(message) {
        var dateString = message.getElementsByTagName('t:DateTimeReceived')[0].textContent;
        var subject = message.getElementsByTagName('t:Subject')[0].textContent;
        var availableProperties = that.getAvailableProperties(message);

        var properties = $.map(availableProperties, function(property) {
          if (property.id === "Subject") {
            return {
              id: "Subject",
              data: [{ html: subject.replaceAll(new RegExp(highlightedTerm, "gi"), function(match)  { return "<em>" + that.escapedHTML(match) + "</em>" }) }]
            }
          } else if (property.id === "DateTimeReceived") {
            return {
              id: "DateTimeReceived",
              data: [{html: new Date(dateString).toLocaleString()}]
            }
          }
          return property;
        });

        return {
          id: message.getElementsByTagName('t:ItemId')[0].getAttribute('Id'),
          properties: properties
        };
      });

      return results;
    },

    escapedHTML: function(htmlString) {
      return $("<div>").text(htmlString).html();
    },

    escapeXML: function(xmlString) {
      return xmlString.replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&apos;');
    },

    getAvailableProperties: function(message) { 
      var that = this;
      var properties = $.map(message.children, function(property){
        if (property.children.length > 0) {
          return that.getPropertyRecursively(property);
        }
        return that.getProperty(property);
      });
      return properties;
    },

    getProperty: function(property) {
      return {
        id: property.tagName.substring(2),
        data: [{ html: property.textContent }]
      }
    },

    getPropertyRecursively: function(property, tagName) {
      var that = this;
      var propertyTagName;
      if (tagName) {
        propertyTagName = tagName.concat('_', property.tagName.substring(2));
      } else {
        propertyTagName = property.tagName.substring(2);
      }
      return $.map(property.children, function(childProperty) {
        if (childProperty.children.length > 0) {
          return that.getPropertyRecursively(childProperty, property.tagName.substring(2));
        }
        return {
          id:  propertyTagName.concat("_", childProperty.tagName.substring(2)),
          data: [{html: childProperty.textContent}]
        }
      })
    }
  });
  
  return EWSChannel;
});

